import { Button, Text } from "$components";
import { useProductFormContext } from "../contexts/ProductFormContext";
import { useStyles } from "../styles/ProductForm.styles";
import useJStyles from "$hooks/useJStyles";
import useAuth from "$hooks/useAuth";

export const FormFooter = () => {
  const classes = useStyles();
  const { jclasses } = useJStyles();
  const { isAdmin, isClient } = useAuth();
  const { onReset, productError, isSubmitting, form } = useProductFormContext();
  const {
    formState: { errors },
  } = form;

  if (!isAdmin() && !isClient()) {
    return null;
  }

  return (
    <>
      {productError && (
        <Text className={classes.errorContainer}>{productError}</Text>
      )}
      <div className={jclasses.footerForm}>
        <Button color="secondary" onClick={onReset}>
          Annuler
        </Button>
        <Button
          type="submit"
          disabled={Object.keys(errors).length > 0 || isSubmitting}
        >
          Enregistrer
        </Button>
      </div>
    </>
  );
};
